import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const PartnerRegister = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        companyName: '',
        orgNr: '',
        contactName: '',
        email: '',
        phone: '',
        motivation: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setStep(2);
        setTimeout(() => {
            alert("Søknad sendt! Vi kontakter deg snart for en prat.");
            navigate('/');
        }, 2500);
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center py-12 px-4">
            <Link to="/" className="mb-8 flex items-center gap-2 text-2xl font-black text-slate-900 hover:text-blue-600 transition-colors">
                <SafeIcon icon="⬅️" className="text-lg" /> Tilbake til forside
            </Link>

            <div className="bg-white max-w-5xl w-full rounded-[2.5rem] shadow-xl border border-slate-200 overflow-hidden flex flex-col md:flex-row">
                
                {/* Left Panel */}
                <div className="md:w-1/3 bg-slate-900 text-white p-8 md:p-12 flex flex-col">
                    <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mb-6 text-2xl shadow-lg">
                        🤝
                    </div>
                    <h2 className="text-3xl font-black mb-4 tracking-tight">Bli Partner</h2>
                    <p className="text-slate-400 font-medium leading-relaxed mb-8">
                        Tjen penger på å anbefale markedets smarteste CRM. Vi gir deg verktøyene du trenger for å lykkes.
                    </p>

                    <div className="space-y-6 mt-auto">
                        <div className="flex items-start gap-4">
                            <SafeIcon icon="💰" className="text-2xl mt-1 text-emerald-400" />
                            <div>
                                <h4 className="font-bold text-white">20% Provisjon</h4>
                                <p className="text-sm text-slate-400">Gjentakende provisjon (MRR) så lenge kunden er aktiv.</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-4">
                            <SafeIcon icon="🛠️" className="text-2xl mt-1 text-blue-400" />
                            <div>
                                <h4 className="font-bold text-white">Partner Portal</h4>
                                <p className="text-sm text-slate-400">Full oversikt over dine leads, salg og utbetalinger.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Panel / Form */}
                <div className="md:w-2/3 p-8 md:p-12">
                    {step === 1 ? (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <h3 className="text-2xl font-black text-slate-900 mb-8">Søknadsskjema</h3>
                            
                            <div className="grid grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Bedriftsnavn</label>
                                    <input required className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 font-bold text-slate-700" value={formData.companyName} onChange={e => setFormData({...formData, companyName: e.target.value})} />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Org. Nummer</label>
                                    <input required className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 font-bold text-slate-700" value={formData.orgNr} onChange={e => setFormData({...formData, orgNr: e.target.value})} />
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Kontaktperson</label>
                                <input required className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 font-bold text-slate-700" value={formData.contactName} onChange={e => setFormData({...formData, contactName: e.target.value})} />
                            </div>

                            <div className="grid grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">E-post</label>
                                    <input required type="email" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 font-bold text-slate-700" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Telefon</label>
                                    <input required type="tel" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 font-bold text-slate-700" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} />
                                </div>
                            </div>

                            <div>
                                <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Hvorfor vil du bli partner?</label>
                                <textarea rows="3" required className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 font-medium text-slate-700 resize-none" placeholder="Fortell litt om nettverket ditt og hvordan du planlegger å selge plattformen..." value={formData.motivation} onChange={e => setFormData({...formData, motivation: e.target.value})} />
                            </div>

                            <button type="submit" className="w-full py-4 bg-blue-600 text-white rounded-xl font-black text-lg uppercase tracking-widest hover:bg-blue-700 shadow-lg transition-all">
                                Send Søknad
                            </button>
                        </form>
                    ) : (
                        <div className="flex flex-col items-center justify-center h-full text-center">
                            <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-4"></div>
                            <h3 className="text-xl font-bold">Behandler søknad...</h3>
                            <p className="text-slate-500">Sender inn detaljene dine til partneransvarlig.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PartnerRegister;